
<template>
  <div>
    <v-dialog :value="dialog" persistent max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Editando dados do funcionário</span>
        </v-card-title>
        <v-card-text>
          <EmployeeFinancialForm ref="form" :employee="employee" @setEmployee="handleSetEmployee"></EmployeeFinancialForm>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <f-btn cancel @click="closeDialog"></f-btn>
          <f-btn save @click="emitUpdate"></f-btn>
        </v-card-actions>
      </v-card>
   </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: 'EmployeeEditFinancialDialog',
  props: {
    employee: {
      type: Object,
      default: () => { return {} },
    },
    change_dialog:{
      type: Boolean,
      default: false,
    }
  },
  components: {
    EmployeeFinancialForm: () => import("@/_backoffice/_registrations/components/employee/forms/EmployeeFinancialForm.vue")
  },
  data() {
    return {
      dialog: false,
      new_employee: {
        id: null,
      },
    }
  },
  methods: {
    emitUpdate(){
      if(this.$refs.form.validate()){
        this.$emit('update', this.new_employee)
      }
    },
    closeDialog(){
      this.$emit('close')
    },
    handleSetEmployee(_new_employee){
      this.new_employee = _new_employee
    },

  },
  watch:{
    change_dialog(nv, old){
      this.dialog = nv
    },
    
  }
}
</script>